import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { If } from 'src/Components'
import Avatar from 'src/Components/shared/Avatar'
import Button from 'src/Components/shared/Button'
import Text from 'src/Components/shared/Text'
import List from 'src/Components/shared/List'
import Phone from 'src/Components/shared/Phone'
import Email from 'src/Components/shared/Email'
import NMLS from 'src/Components/shared/NMLS'
import PrequalRequested from 'src/Components/buyers/Global/AffordabilityModal/PrequalRequested'

import styles from './AffordabilityPromptPrequal.module.scss'

const AffordabilityPromptPrequal = ({
  className,
  customerProfileEmail,
  customerProfileFirstName,
  customerProfilePhotoUri,
  isSponsored,
  onConfirm,
  onReject,
  requested,
  sponsorPhotoUri,
  sponsorProfileCorporationName,
  sponsorProfileEmail,
  sponsorProfileFullName,
  sponsorProfileNmls,
  sponsorProfilePhone
}) => (
  <>
    <If condition={requested}>
      <PrequalRequested className={styles.requestContainer} />
    </If>
    <If condition={!requested}>
      <div className={styles.avatars}>
        <Avatar className={styles.avatar} src={customerProfilePhotoUri} />
        <If condition={isSponsored}>
          <Avatar
            className={classnames(styles.cospo, styles.avatar)}
            src={sponsorPhotoUri}
          />
        </If>
      </div>
      <Text paragraph size='s' color='quiet' className={styles.body}>
        <If condition={isSponsored}>
          <FormattedMessage
            id='Affordability.promptPrequal.cospo.heading'
            defaultMessage='Get professional advice about your price point by ordering a quick prequal so you can buy smarter and be a more competitive bidder. {rea} recommends {lo}, a lender they trust. Do you want to double check your numbers?'
            values={{
              rea: customerProfileFirstName,
              lo: sponsorProfileFullName
            }}
          />
        </If>
        <If condition={!isSponsored}>
          <FormattedMessage
            id='Affordability.promptPrequal.directLO.heading'
            defaultMessage='{customer} can double check your numbers and get you prequalified, which will improve your chances of a seller selecting your offer.'
            values={{
              customer: customerProfileFirstName
            }}
          />
        </If>
      </Text>
      <div className={styles.buttons}>
        <Button
          primary
          onClick={onConfirm}
          data-qa='prequalPrompt.confirmButton'
        >
          <FormattedMessage id='Prompt.confirm' defaultMessage='Yes' />
        </Button>
        <Button onClick={onReject} data-qa='prequal-prompt-reject-button'>
          <FormattedMessage id='Prompt.reject' defaultMessage='Not Now' />
        </Button>
      </div>
      <If condition={isSponsored}>
        <Text element='div' size='s' color='quiet' className={styles.contact}>
          <List.Bulleted.Inline>
            {sponsorProfileFullName}
            {sponsorProfileCorporationName}
          </List.Bulleted.Inline>

          <List.Bulleted.Inline>
            <Phone value={sponsorProfilePhone} />
            <Email value={sponsorProfileEmail} />
            <NMLS value={sponsorProfileNmls} />
          </List.Bulleted.Inline>
        </Text>
      </If>
    </If>
  </>
)

export default AffordabilityPromptPrequal
